import { FormAutocomplete, FormInputText } from '../../dsn-kernel'
import { Types } from '../../store/constants/fonction/fonction'
import React from 'react'
import { useSelector } from 'react-redux'
import { useWatch } from 'react-hook-form'

export const ChoixType = ({ classes, useFormObj, withValeurDefaut = false }) => {
  const { control, getValues, setValue } = useFormObj
  const type = useWatch({ control: control, name: 'type' })
  const referenceObj = useWatch({ control: control, name: 'referenceObj' })
  const referentiels = useSelector(state => state.referentiels.referentiels)
  const validator = value => {
    const type = getValues('type')
    if (!type || !value) return true
    return Types[type].validate(value) || "La valeur saisie n'est pas conforme au type '" + Types[type].label + "'"
  }
  return (
    <>
      <FormAutocomplete
        label={'Type'}
        name="type"
        control={control}
        rules={{ required: true }}
        getOptionLabel={option => Types[option].label}
        options={Object.keys(Types)}
        onChange={(event, value, reason, details) => {
          setValue('referenceObj', null)
          setValue('reference', null)
          setValue('valeurDefautObj', null)
          setValue('valeurDefaut', '')
        }}
      />
      {Types[type] === Types.REFERENCE && (
        <FormAutocomplete
          label={'Référentiel'}
          name="referenceObj"
          control={control}
          rules={{ required: true }}
          getOptionLabel={option => option.nom}
          getOptionSelected={(option, value) => option.nom === value.nom}
          onChange={(event, value, reason, details) => {
            setValue('valeurDefautObj', null)
            setValue('valeurDefaut', null)
          }}
          options={referentiels}
        />
      )}
      {withValeurDefaut && Types[type] === Types.REFERENCE && (
        <FormAutocomplete
          label={'Valeur par defaut'}
          name="valeurDefautObj"
          control={control}
          getOptionLabel={option => (option ? `${option.code} - ${option.libelle}` : '')}
          getOptionSelected={(option, value) => option.code === value.code}
          disabled={!referenceObj}
          options={
            referenceObj && referenceObj.nom ? referentiels.find(ref => ref.nom === referenceObj.nom)?.values : []
          }
        />
      )}
      {withValeurDefaut && Types[type] !== Types.REFERENCE && (
        <FormInputText
          label={'Valeur par defaut'}
          name="valeurDefaut"
          type={Types[type] === Types.DATE ? 'date' : ''}
          rules={{ validate: validator }}
          control={control}
        />
      )}
    </>
  )
}
